import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { useResponsiveValue } from '#/hooks';
import { BreakpointKeys } from '#/service/constants';
import { remify } from '#/service/utils';

import FooterAccordion from './FooterAccordion';
import FooterColumns from './FooterColumns';
import Info from './Info';
import { FooterDivProps, ResponsiveProps } from './types';

const FooterContainer = styled.footer`
  background-color: var(--pageBackground);
  padding-top: ${remify(50)};
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;

  a {
    color: var(--pageParagraphForeground);
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }
`;

const disabledRoutes = ['playback', 'updatePassword', 'forgotPassword'];

const Footer: FC<FooterDivProps> = ({ footer }) => {
  const { Component } = useResponsiveValue<ResponsiveProps>(breakpointMap);
  const { enabled, columns, copyright, contact, socials } = footer;

  const location = useLocation();

  // TODO: Our current settings page design looks bad with the footer, when we've moved to the new designs, remove this.
  const paths = location.pathname?.split('/') || ['', ''];
  const atSettingsPage = disabledRoutes.includes(paths[1]);

  if (!enabled || atSettingsPage) {
    return null;
  }

  return (
    <FooterContainer>
      {!!columns && <Component columns={columns} />}
      <Info contact={contact} copyright={copyright} socials={socials} />
    </FooterContainer>
  );
};

export default Footer;

const breakpointMap = {
  [BreakpointKeys.XS]: { Component: FooterAccordion },
  [BreakpointKeys.SM]: { Component: FooterAccordion },
  [BreakpointKeys.MD]: { Component: FooterAccordion },
  [BreakpointKeys.LG]: { Component: FooterAccordion },
  [BreakpointKeys.XL]: { Component: FooterColumns },
  [BreakpointKeys.XXL]: { Component: FooterColumns },
};
